import { FC } from "react";
import { Routes, Route } from "react-router-dom";
import { CountriesGrid } from "../countries/dataGrid";
import { CompletedCountriesGrid } from "../countries/completedGrid";
import { CountryPage } from "../country";
import { CountrySignOff } from "../country/signOff";
import { RequestNewCountry } from "../requestNew";
import { MyCountryRequests } from "../myRequests";

type Props = {};

export const CountriesRoutes: FC<Props> = () => {
  return (
    <Routes>
      <Route path="country/:id/signoff" element={<CountrySignOff />} />
      <Route path="country/:id/*" element={<CountryPage />} />
      <Route path="request-new" element={<RequestNewCountry />} />
      <Route path="my-requests" element={<MyCountryRequests />} />
      <Route path="completed" element={<CompletedCountriesGrid />} />
      <Route path="/*" element={<CountriesGrid />} />
    </Routes>
  );
};
